<div class="p-4">
  <div class="container">
    <h1>{{ Dashboard }}</h1>
    <p></p>
    <router-outlet></router-outlet>
  </div>
</div>
